module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "label": "提交时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "daterange",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeTimeTj
    },
    model: {
      value: (_vm.tijiaoTime),
      callback: function($$v) {
        _vm.tijiaoTime = $$v
      },
      expression: "tijiaoTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "label": "审核时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "daterange",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeTimeSh
    },
    model: {
      value: (_vm.shTime),
      callback: function($$v) {
        _vm.shTime = $$v
      },
      expression: "shTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状态："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ztid),
      callback: function($$v) {
        _vm.ztid = $$v
      },
      expression: "ztid"
    }
  }, _vm._l((_vm.zhuangtai), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("分享审核")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享内容",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.taskname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享类型",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tasktypename))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖金（元）",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.bonus))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交时间",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.submittime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.statusname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.operatorname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作时间",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.audittime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status == 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-s-check"
        }), _vm._v(" 审核 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.initTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.detailsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.detailsDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('span', {
          staticClass: "drawer_title"
        }, [_vm._v("详情")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "2px solid #eee",
      "margin-bottom": "10px",
      "padding-top": "10px"
    }
  }, [_c('b', [_vm._v("任务信息")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("分享内容：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.taskname))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("分享类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.tasktypename))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("分享文案：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.remark))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("截止日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.enddate))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("任务奖励：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3BB575"
    }
  }, [_vm._v("￥" + _vm._s(_vm.formDetails.bonus) + "元")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("任务规则：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-table"
    }
  }, _vm._l((_vm.formDetails.rules), function(item) {
    return _c('ul', {
      key: item
    }, [_c('li', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_vm._v(_vm._s(item.sort) + "." + _vm._s(item.taskdesc) + ";")])])
  }), 0)])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("任务进度")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto"
    }
  }, _vm._l((_vm.formDetails.progress), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "rwjdList"
    }, [_c('div', {
      class: index == 0 ? 'roundIcon roundActive' : 'roundIcon'
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== _vm.formDetails.progress.length - 1),
        expression: "index!==formDetails.progress.length-1"
      }],
      class: item.status >= index + 2 ? 'jdt lineActive' : 'jdt'
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#999",
        "margin-left": "20px"
      }
    }, [_vm._v(_vm._s(item.createtime))]), _vm._v(" "), _c('p', {
      class: item.isfail == 1 ? 'redClass' : '',
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v(_vm._s(item.progressname) + " "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.remark),
        expression: "item.remark"
      }]
    }, [_vm._v("：" + _vm._s(item.remark))])]), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status == 1),
        expression: "item.status==1"
      }],
      staticClass: "videoandpic"
    }, _vm._l((_vm.processedData), function(item, index) {
      return _c('li', {
        key: index
      }, [_c('el-image', {
        staticStyle: {
          "width": "80px",
          "height": "80px"
        },
        attrs: {
          "src": item.videoimgFullUrl,
          "preview-src-list": [item.videoimgFullUrl]
        },
        on: {
          "click": _vm.handleClickItem
        }
      }), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.datatype == 2),
          expression: "item.datatype == 2"
        }],
        staticClass: "trans",
        on: {
          "click": function($event) {
            return _vm.palySeevideo(item)
          }
        }
      }, [_c('img', {
        staticClass: "mengceng",
        attrs: {
          "src": require("../../assets/img/play.png")
        }
      })])], 1)
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "drawer_foot"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateType == 2),
      expression: "stateType==2"
    }],
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.careful(3)
      }
    }
  }, [_vm._v("不通过")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateType == 2),
      expression: "stateType==2"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.careful(2)
      }
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateType == 1),
      expression: "stateType==1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailsDialog = false
      }
    }
  }, [_vm._v("返回")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "审核不通过",
      "visible": _vm.seeTksh,
      "center": true,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.seeTksh = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "不通过理由："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  }, _vm._l((_vm.statusoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.dDicId,
        "label": item.dDicName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdTksh()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.seeTksh = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "35%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-881715a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/shareReview.vue
// module id = 1723
// module chunks = 3